/**
 * Given a duration in seconds, return a string in the format 'mm:ss'
 * @param duration
 * @returns formatted duration string in 'mm:ss' format
 */
export function formatDuration(duration: number): string {
    // Remainder of division by 60 and floor the result (get the nearest lower integer)
    const seconds = Math.floor(duration % 60);
    // Divide by 60 and floor the result (get the nearest lower integer)
    const minutes = Math.floor(duration / 60);

    // Put it all in one string
    return ('' + minutes).padStart(2, '0') + ':' + ('' + seconds).padStart(2, '0');
}
